module.exports = __webpack_public_path__ + "img/avatar4.4c10373b.png";